// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--ABXwO","title-wrapper":"_9e1425b4d3--title-wrapper--X3S9t","similar-article-wrapper":"_9e1425b4d3--similar-article-wrapper--QTQpc"};